<template>
  <fieldset>
    <legend class="body-1-bold mb-12">{{ i18n(translations.title) }}</legend>
    [LIST OF TAGS]
  </fieldset>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './AITags.translations'

const i18n = useI18n()
</script>
